import gql from 'graphql-tag';

export default gql`
  mutation rsvpCollegeFair($input: rsvpCollegeFairInput!) {
    rsvpCollegeFair(input: $input) {
      collegeFair {
        id
        attending
        status
        currentColleges
        version
      }
    }
  }
`;
